import { Injectable } from '@angular/core';
import { UserRoles } from 'src/app/core/enums/user-roles.enum';

@Injectable({
  providedIn: 'root',
})
export class DevicePersmissionsUtilsService {
  canAddEditDeleteDeviceAdmin(role: string): boolean {
    return (
      role === UserRoles.ADMIN ||
      role === UserRoles.GROUPADMIN ||
      role === UserRoles.GROUPMANAGER ||
      role === UserRoles.GROUP_COORDINATOR
    );
  }
}
